import { Menu, Tag } from 'antd';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FacebookOutlined, YoutubeOutlined } from "@ant-design/icons";

const NavigationMenu = () => {
    const items = [
        {
            label: 'मुख्य पृष्ठ',
            key: 'मुख्यपृष्ठ',
            path: '/'
        },
        {
            label: 'मान्यवर',
            key: 'मान्यवर',
            path: '/manyavar'
        },
        {
            label: 'पदाधिकारी',
            key: 'पदाधिकारी',
            path: '/padadhikari'
        },
        {
            label: 'अधिकारी',
            key: 'अधिकारी',
            path: '/officers'
        },
        {
            label: 'माहितीचा अधिकार',
            key: 'माहितीचाअधिकार',
            path: '/rightToInfomtion'
        },
        {
            label: 'नाविन्यपूर्ण उपक्रम',
            key: 'उपक्रम',
            path: '/initiations'
        },
        {
            label: 'जाहिरात',
            key: 'जाहिरात',
            path: '/advertising'
        },
        {
            label: 'तक्रार निवारण',
            key: 'तक्रारनिवारण',
            path: '/public-grievance'
        },
        // {
        //     label: 'संपर्क',
        //     key: 'संपर्क',
        //     path: '/contact'
        // },
        {
            label: 'नागरिकांची सनद',
            key: 'नागरिकांचीसनद',
            path: '/sanad'
        }
    ];

    const [current, setCurrent] = useState('मुख्यपृष्ठ');

    const onClick = e => {
        setCurrent(e.key);
    };

    return (
        <>
            <div style={{ display: "flex", flexDirection: "row", paddingBottom: 6, justifyContent: "flex-end" }}>
                <Link to={"/aboutus"} style={{ color: "#000000", fontWeight: "bold", paddingRight: 12 }}>About</Link>
                <Link to={"/contact"} style={{ color: "#000000", fontWeight: "bold", paddingRight: 12 }}>Contact</Link>
                <Tag icon={<YoutubeOutlined />} color="#cd201f">
                    <a href="https://www.youtube.com/channel/UCDWermPXLHxtJHLqKwtVISg" target="_blank" rel="noopener noreferrer">Youtube</a>
                </Tag>
                <Tag icon={<FacebookOutlined />} color="#3b5999">
                    <a href="https://https://www.facebook.com/profile.php?id=100079367245847" target="_blank" rel="noopener noreferrer">Facebook</a>
                </Tag>
            </div>
            <Menu selectedKeys={[current]} mode="horizontal" items={items.map(item => {
                return {
                    key: item.key,
                    label: (<Link to={item.path} onClick={() => onClick(item)}>{item.label}</Link>)
                }
            })} />
        </>
    );
}

export default NavigationMenu;